import { runtimeConfig } from '../../shared/utils/config-utils';
import { EventEmitter } from '@angular/core';
import { SalesChannel } from '../consts/sales-channel.enum';
import { Observable } from 'rxjs/Rx';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import * as _ from 'lodash';
import {KeyValueItem} from '../../shared/models/key-value-item';

export function noop() {
}

export function utf8ToB64(str: string) {
  return btoa(encodeURIComponent(str));
}

export function b64ToUtf8(str) {
  return decodeURIComponent(atob(str));
}

export function base64MimeType(encoded: string): string {
  let result = null;
  if (typeof encoded !== 'string') {
    return result;
  }
  const mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
  if (mime && mime.length) {
    result = mime[1];
  }
  return result;
}

// export function isMobile(): boolean {
//  return runtimeConfig().appConfig.mobile;
// }

export function configurationCode(): string {
  return runtimeConfig().configurationCode;
}

export function salesChannel() {
  return runtimeConfig().salesChannel;
}

export function env(): string {
  return runtimeConfig().env;
}

export function getCurrencyTranslation(currency: string): string {
  if (currency === 'PLN') {
    return 'zł';
  } else if (currency === 'EUR') {
    return '€';
  }
  return '';
}

export const beforeUnloadEvent = (event) => {
  event.returnValue = `Wprowadzone zmiany mogą nie zostać zapisane.`;
};

export const fillFormEvent: EventEmitter<any> = new EventEmitter();

export const onlineEvent: Observable<Event> = fromEvent(window, 'online');

export function addDaysToDate(date: Date, days: number): Date {
  let targetDate = date.getDate() + days;
  date.setDate(targetDate);
  return date;
}

export function changeDateByYears(date: Date, years: number): Date {
  date.setFullYear(date.getFullYear() + years);
  return date;
}
export function hideSpinner(): void {
  const spinner = document.querySelector('#spinner');
  spinner.classList.add('spinner-wrapper--hidden');

  const appRoot = document.querySelector('#appRoot');
  appRoot.classList.remove('display-none');
}

export function markBodyConfigurationReady(): void {
  const body = document.querySelector('body');
  body.classList.add('body--configuration-ready');
}

export function isMobile(customWidth?: number): boolean {
  const MOBILE_WIDTH = 879;
  if (customWidth) {
    return customWidth <= MOBILE_WIDTH;
  }
  return window.innerWidth <= MOBILE_WIDTH;
}

export function isWindowWidthSmaller(maxWidth: number): boolean {
  return window.innerWidth <= maxWidth;
}

export function visibleInCustomWidth(customWidth?: number): boolean {
  return window.innerWidth >= customWidth;
}

export function isIOS(): boolean {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
}

export function isKIOSKPOLIS() {
  return salesChannel() === SalesChannel.KIOSKPOLIS;
}

export function isYANOSIK() {
  return salesChannel() === SalesChannel.YANOSIK;
}

export function isNotYANOSIK() {
  return salesChannel() !== SalesChannel.YANOSIK;
}

export function isOLX() {
  return salesChannel() === SalesChannel.OLX;
}

export function isMPay() {
  return salesChannel() === SalesChannel.MPAY;
}

export function isSkycash() {
  return salesChannel() === SalesChannel.SKYCASH;
}

export function isCarOne() {
  return salesChannel() === SalesChannel.CARONE;
}

export function isNestBank() {
  return salesChannel() === SalesChannel.NESTBANK;
}

// Moto 3.0 design
export function isNext(): boolean {
  return isKIOSKPOLIS() || isCarOne() || isNestBank();
}

export function orderCall(): void {
  if (!isMPay()) {
    window.open('https://kioskpolis.pl/zamow-rozmowe/', '_blank');
  } else {
    window.open('https://ubezpieczenia.mpay.pl/kontakt/', '_blank');
  }
}

export function randomAlphanumeric(length: number): string {
  return Array(length).fill(0).map(x => Math.random().toString(36).charAt(2)).join('');
}

export function redirectTo(uri: string): void {
  window.removeEventListener('beforeunload', beforeUnloadEvent);
  window.location.href = uri;
}

export function redirectParentTo(uri: string): void {
  window.removeEventListener('beforeunload', beforeUnloadEvent);
  if (isNotNullOrUndefined(window.top)) {
    window.top.location.href = uri;
  }
}

/**
 * returns Promise that resolves when image resource is loaded by browser
 */
export function getImage(url: string): Promise<void> {
  return new Promise(resolve => {
    const img = document.createElement('img');
    img.src = url;
    img.addEventListener('load', () => resolve());
  });
}

export function navigateBack(steps: number): void {
  for (let i = 0; i < steps; i++) {
    window.history.back();
  }
}

export function logoUrl(): string {
  return './assets/images/logo/kioskpolis-rgb.svg';
}

export function isPromise(o: any): boolean {
  return typeof o.then === 'function';
}

export function isArray(o: any): boolean {
  return o instanceof Array;
}

export function removeUndefinedOrNullFromObject(o: any): any {
  Object.keys(o).forEach(propertyName => {
    if (!isNotNullOrUndefined(o[propertyName])) {
      delete o[propertyName];
    }
  });
  return o;
}

export function fixNonBreakingSpaceInObject(o: any): any {
  Object.keys(o).forEach(propertyName => {
    const shouldProcess = !!o[propertyName] && _.isString(o[propertyName]);
    if (shouldProcess && o[propertyName].includes('&nbsp;')) {
      o[propertyName] = o[propertyName].replace('&nbsp;', ' ');
    }
  });
  return o;
}

export function shouldTranslate(str: string): boolean {
  return str.includes('.') && !str.includes(' ');
}

export function addParamsToUrl(urlString: string, params: KeyValueItem[]): string {
  const url = new URL(urlString);
  params.forEach(param => url.searchParams.set(param.key, param.value));
  return url.href;
}

export function landingPageUrl(): string {
  return 'https://kioskpolis.pl/';
}

export function isEmbeddedInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export function loadScript(url: string): Promise<void> {
  return new Promise(res => {
    const script = document.createElement('script');
    script.onload = () => {
      res();
    };
    script.src = url;
    document.head.appendChild(script);
  });
}

export function updateOrCreateFavicon(href: string): void {
  let faviconElement: any = document.querySelector('link[rel~=\'icon\']');
  if (!isNotNullOrUndefined(faviconElement)) {
    faviconElement = document.createElement('link');
    faviconElement.rel = 'icon';
    document.head.appendChild(faviconElement);
  }
  faviconElement.href = href;
}
